<template>
  <v-app>
    <Snackbar :SnackBarComponent="SnackBarComponent"></Snackbar>
    <Overlay :overlay="overlay" />
    <v-app-bar flat color="transparent" class="px-4 pt-4" v-if="mounted">
      <v-app-bar-title> </v-app-bar-title>
    </v-app-bar>

    <v-main class="d-flex align-center justify-center whole-background" v-if="mounted">
      <v-container fluid>
        <v-row justify="center" align="center">
          <v-col cols="12" md="10" lg="8">
            <v-card elevation="12" class="rounded-xl overflow-hidden">
              <v-row no-gutters>
                <v-col cols="12" md="6" class="md-and-up-only">
                  <v-card class="card-background" elevation="0" density="compact">
                  </v-card>
                </v-col>

                <v-col cols="12" md="6" class="pa-8">
                  <div align="center" class="mb-2">
                    <v-img width="157" cover src="@/assets/EztrackBlackLogo.png"></v-img>
                  </div>
                  <v-window v-model="step" class="px-1">
                    <v-window-item :value="1">
                      <h1 class="mb-1 text-center">Welcome Back!</h1>
                      <p class="fontVariant3 mb-4 text-center">
                        Enter your email to get started
                      </p>
                      <v-form ref="form">
                        <v-text-field color="primary" v-model="EmailID" label="Email Address*"
                          placeholder="Enter your email" variant="outlined" :rules="[
                            (v) => !!v || 'Email is required',
                            (v) =>
                              /^\S+@\S+\.\S+$/.test(v) ||
                              'Invalid email format',
                          ]" class="mb-4" required @keydown.enter.prevent="validateSignInForm">
                          <template v-slot:prepend-inner>
                            <div align="center">
                              <v-icon color="primary">mdi-email</v-icon>
                            </div>
                          </template>
                        </v-text-field>

                        <v-btn class="fontVariant3 rounded-lg" block size="large" variant="flat"
                          :loading="buttonLoading" color="primary" @click="validateSignInForm()">Send otp</v-btn>
                      </v-form>

                      <v-divider class="my-6"></v-divider>

                      <p align="center">
                        Dont' have an account ?
                        <span class="cursorPointer text-primary" @click="gotoStep3">Sign up</span>
                      </p>
                    </v-window-item>
                    <v-window-item :value="2">
                      <div align="end">
                        <v-icon color="primary" @click="goBacktoStep01">mdi-arrow-left-bold</v-icon>
                      </div>
                      <h1 class="mb-1 text-center">Welcome Back!</h1>
                      <p class="fontVariant3 mb-4 text-center">
                        Please enter the OTP that was sent to your registered
                        EmailID:
                      </p>
                      <v-card-text class="pa-2">
                        <v-otp-input autofocus ref="otpInput" elevation="0" :length="6" v-model="otp"
                          :loading="otpLoading" @keydown.enter.prevent="validateVerifyOtpMethod"></v-otp-input>
                        <div class="d-flex align-center mx-3 mb-2">
                          <v-btn :disabled="otp.length < 6 || otpLoading" class="fontVariant3" block variant="flat"
                            :loading="buttonLoading" color="primary" @click="validateVerifyOtpMethod()">Login</v-btn>
                        </div>

                        <div class="fontVariant3 text-center mt-6">
                          <div class="my-2">
                            <v-divider></v-divider>
                          </div>
                          Didn't receive the OTP?
                          <span class="fontVariant3 text-primary cursorPointer"
                            @click="validateSignInForm()">Resend</span>
                          code.
                        </div>
                      </v-card-text>
                    </v-window-item>

                    <v-window-item :value="3">
                      <div v-if="step == 3" class="d-flex align-center mx-2">
                        <b align="center">Signup Organization</b>
                        <v-spacer></v-spacer>
                        <v-icon color="primary" @click="goBacktoStep01">mdi-arrow-left-bold</v-icon>
                      </div>
                      <v-form ref="signUpForm">
                        <v-row no-gutters>
                          <v-col cols="12" sm="12" md="12" class="pa-0 mt-2">
                            <v-text-field density="compact" variant="outlined" elevation="0" color="primary"
                              label="Organization name*" placeholder="Organization name*"
                              :rules="[(v) => !!v || 'Required']" v-model="signUpOrganizationInputs.organization_name
                                " class="mx-2 mt-2 field_label_size field_font field_height"></v-text-field>
                          </v-col>

                          <!-- <v-col cols="12" sm="12" md="12" class="pa-0">
                            <v-select v-model="signUpOrganizationInputs.organization_industry_type
                              " density="compact" variant="outlined" elevation="0" color="primary"
                              :items="getAllIndustryTypes" item-title="industry_type_name"
                              item-value="industry_type_name" label="Industry types" :rules="[(v) => !!v || 'Required']"
                              class="mx-2 mt-2 field_label_size field_font field_height"></v-select>
                          </v-col>  -->



                          <v-col cols="12" sm="12" md="6" class="pa-0 mt-2">
                            <v-autocomplete v-model="signUpOrganizationInputs.user_country_code
                              " :items="GetCountryCodes" item-value="dial_code" item-title="name" density="compact"
                              variant="outlined" elevation="0" color="primary" label="Country code*"
                              placeholder="Enter your  Country code*" :rules="[(v) => !!v || 'Required']"
                              :item-props="itemProps" class="mx-2 mt-2 field_label_size field_font field_height">


                              <template #item="{ props, item }">

                                <v-list-item class="mx-2" width="300" v-bind="props" :title="item.raw.name"
                                  :subtitle="item.raw.dial_code" />

                              </template>




                            </v-autocomplete>
                          </v-col>



                          <v-col cols="12" sm="12" md="6" class="pa-0 mt-2">
                            <v-text-field v-model="signUpOrganizationInputs.user_contact_number
                              " density="compact" variant="outlined" elevation="0" color="primary"
                              label="Contact person phone no*" placeholder="Enter Contact person phone no*"
                              :rules="[(v) => !!v || 'Required']"
                              class="mx-2 mt-2 field_label_size field_font field_height"></v-text-field>
                          </v-col>

                          <v-col cols="12" sm="12" md="12" class="pa-0 mt-2">
                            <v-text-field v-model="signUpOrganizationInputs.user_name" density="compact"
                              variant="outlined" elevation="0" color="primary" label="Contact person name*"
                              placeholder="Enter your Contact person name*" :rules="[(v) => !!v || 'Required']"
                              class="mx-2 mt-2 field_label_size field_font field_height"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="pa-0 mt-2">
                            <v-text-field v-model="signUpOrganizationInputs.user_email_id" density="compact"
                              variant="outlined" elevation="0" color="primary" label="Contact person emailId*"
                              placeholder="Enter your Contact person emailId*" :rules="[
                                (v) => !!v || 'Email is required',
                                (v) =>
                                  /^\S+@\S+\.\S+$/.test(v) ||
                                  'Invalid email format',
                              ]" class="mx-2 mt-2 field_label_size field_font field_height"></v-text-field>
                          </v-col>
                          <v-divider></v-divider>
                          <v-col cols="12" sm="12" md="12" class="pa-0 mt-2">
                            <v-btn class="fontVariant3 rounded-lg" block size="large" variant="flat"
                              :loading="buttonLoading" color="primary" @click="validateSignUpForm">Submit</v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-window-item>
                  </v-window>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { signIn, signOut, confirmSignIn } from "aws-amplify/auth";
import { getCurrentUser } from "aws-amplify/auth";
import Snackbar from "@/components/Extras/Snackbar.vue";
import Overlay from "@/components/Extras/Overlay.vue";
import axios from "axios";
import { getAllListIndustryTypes } from "@/mixins/RestApis/getAllListIndustryTypes";
import getcountry from "@/JsonFiles/CountryList.json";
import { getAllListPlans } from "@/mixins/RestApis/getAllListPlans";
export default {
  components: {
    Snackbar,
    Overlay,
  },
  mixins: [getAllListIndustryTypes, getAllListPlans],

  data() {
    return {
      overlay: true,
      buttonLoading: false,
      otpLoading: false,
      loadingUser: false,
      mounted: false,
      height: 0,
      windowHeight: 0,
      step: 1,
      EmailID: "",
      otp: "",
      user: "",
      GetCountryCodes: [],
      getAllIndustryTypes: [],
      SnackBarComponent: {},
      getAllListPlansArray: [],
      signUpOrganizationInputs: {
        user_email_id: "",
        user_name: "",
        user_country_code: "",
        user_contact_number: "",
        organization_name: "",
        organization_industry_type: "",
      },
    };
  },

  watch: {

    step(value) {
      if (value && value === 2) {
        this.$nextTick(() => {
          this.$refs.otpInput.focus();
        });
      }
    },
  },
  async mounted() {
    this.overlay = true;
    this.windowHeight = window.innerHeight - 50;
    this.GetCountryCodes = getcountry;
    let result = await this.getCurrentUsermethod();
    if (result && result.status === "SUCCESS") {
      this.ActivateMethod();
    } else {
      this.mounted = true;
      await this.getAllListPlansMethod()
    }
    // this.disableBrowserArrowIcons();
  },

  methods: {
    async getCurrentUsermethod() {
      this.overlay = true;
      try {
        const { username, userId, signInDetails } = await getCurrentUser();
        signInDetails.username = username;
        signInDetails.userId = userId;
        //console.log("signInDetails", signInDetails);
        return {
          status: "SUCCESS",
          data: { ...signInDetails },
        };
      } catch (error) {
        //console.log("error", error);
        return {
          status: "ERROR",
          data: error.message,
        };
      } finally {
        this.overlay = false;
      }
    },
    itemProps(item) {
      return {
        title: item.name,
        subtitle: item.dial_code,
      };
    },
    goBacktoStep01() {
      if (this.step === 3) {
        this.$refs.signUpForm.reset();
      } else {
        this.otp = "";
      }
      this.step = 1;
    },
    async validateSignUpForm(action) {
      let isValid = await this.$refs.signUpForm.validate();
      // console.log("signUpOrganizationInputs", this.signUpOrganizationInputs);
      if (isValid.valid) {
        await this.signUpOrganizationMethod();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: "Fields marked with asterisks (*) are mandatory",
        };
      }
    },
    async signUpOrganizationMethod() {
      this.buttonLoading = true;
      const apiUrl =
        process.env.VUE_APP_AWS_SIGN_UP_ORGANIZATION_REST_API_END_POINT;
      //console.log("apiUrl", apiUrl);
      const inputParams = {
        ...this.signUpOrganizationInputs,
        plan: this.getAllListPlansArray[0]
      }
      console.log('input Params', inputParams)
      try {
        const result = await axios.post(apiUrl, inputParams, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (result.data.status === "SUCCESS") {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: result.data.status_message,
          };
          this.goBacktoStep01();
        }
        if (result.data.errorType) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: result.data.errorMessage,
          };
        }
        //console.log("result of signUpOrganizationMethod", result);
      } catch (error) {
        //console.error("Error in signUpOrganizationMethod:", error);

        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error,
        };
      } finally {
        this.buttonLoading = false;
      }
    },

    disableBrowserArrowIcons() {
      //console.log("Domain", window.location.hostname);
      if (window.location.hostname === "localhost") {
        // Push a state to history
        history.pushState(null, null, window.location.href);

        // Add an event listener for the popstate event
        window.addEventListener("popstate", function () {
          // Push the state again to prevent navigation
          history.pushState(null, null, window.location.href);
        });

        //console.log("Navigation buttons disabled on localhost:8081");
      }
    },

    gotoStep3() {
      this.signUpOrganizationInputs.user_country_code = "+65";
      this.step = 3;
    },

    async validateSignInForm() {
      this.otp = "";
      this.buttonLoading = true;
      let isValid = await this.$refs.form.validate();
      if (isValid.valid) {
        //console.log("isValid.valid", isValid.valid);
        await this.SignInWithOtpMethod();
      } else {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: "Fields marked with asterisks (*) are mandatory",
        };
        this.buttonLoading = false;
      }
    },

    async SignInWithOtpMethod() {
      //console.log("called");
      try {
        //console.log("this.EmailID.trim()", this.EmailID.trim());
        this.user = await signIn({
          username: this.EmailID.trim(),
          options: {
            authFlowType: "CUSTOM_WITHOUT_SRP",
          },
        });
        //console.log("result of SignInWithOtpMethod step-1", this.user);
        if (
          this.user.nextStep.signInStep ==
          "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
        ) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: `Verification OTP sent to ${this.EmailID}`,
          };
          this.step = 2;
        }
      } catch (error) {
        //console.log("error in SignInWithOtpMethod step-1", error);
        if (error.message == "There is already a signed in user.") {
          await this.logoutMethod(this.EmailID);
        }
        if (
          error.message ===
          "DefineAuthChallenge failed with error Error: NOT_AUTHORIZED : Kindly Sigup."
        ) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            Top: true,
            SnackbarText: "User Not Found",
          };
        }

        let errorMessage =
          error.message ===
          "DefineAuthChallenge failed with error Error: NOT_AUTHORIZED : Kindly Sigup." ||
          error.message == "There is already a signed in user.";
        if (!errorMessage) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "error",
            Top: true,
            SnackbarText: error.message,
          };
        }
      } finally {
        this.buttonLoading = false;
      }
    },

    async logoutMethod(EmailID) {
      this.buttonLoading = true;
      try {
        const user = await signOut({
          username: EmailID,
        });

        await this.validateSignInForm();
      } catch (error) {
        //console.error("Error in logoutMethod", error);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error.message,
        };
        throw error;
      } finally {
        this.buttonLoading = false;
      }
    },
    async validateVerifyOtpMethod() {
      this.otpLoading = true;
      //console.log("this.otp", this.otp);
      try {
        let result = await confirmSignIn({ challengeResponse: this.otp });
        //console.log("result of validateVerifyOtpMethod method", result);
        if (result.nextStep.signInStep === "DONE") {
          this.$store.commit("SET_USER_EMAIL_ID", this.EmailID);
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "Login Success",
          };
          this.ActivateMethod();
        }
      } catch (error) {
        // //console.log("error in validateVerifyOtpMethod ", error);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error.message,
        };
      } finally {
        this.otpLoading = false;
      }
    },
    ActivateMethod() {
      const redirectPath = this.$route.query.redirect;
      if (redirectPath && typeof redirectPath === "string" && redirectPath.startsWith("/")) {
        this.$router.push(redirectPath);
      } else {
        this.$router.push("/LandingPage");
      }
      this.overlay = false;
    },
  },
};
</script>

<style scoped>
.whole-background {
  background-image: url("@/assets/gradient_blue_background.png");
  background-size: cover;
  background-position: center;
}

.card-background {
  background-image: url("@/assets/LoginPageCard.jpg");
  background-size: cover;
  background-position: center;
  height: 100%;
}

.md-and-up-only {
  display: none;
}

@media (min-width: 960px) {
  .md-and-up-only {
    display: block;
  }
}
</style>
